import { Alert } from 'react-bootstrap';
import { useState, useEffect } from 'react';

const BLOCK = 'LS__app_alert_react_bootstrap';

const LS = (element) => `${BLOCK}__${element}`;

/*
    🔥 ALERT INLINE — react-bootstrap

    Única implementación DECLARATIVA: se renderiza donde la ponés.
    Las otras cinco son toasts imperativos.
*/

const FALLBACK = {
    type: 'info', title: 'PERRON', text: 'Mensaje de ejemplo',
    dismissible: true, autoClose: 0, // 0 = no se cierra solo. 4000 = 4 segundos
};

export const AlertReactBootstrap = ({ type, title, children, onClose, dismissible, autoClose, show }) => {

    const [useIsVisible, setIsVisible] = useState(true);

    const DELAY = autoClose ?? FALLBACK.autoClose;

    const onHandleClose = () => {
        setIsVisible(false);
        if (onClose) onClose();
    };

    useEffect(() => {
        if (!DELAY || !useIsVisible) return;
        const TIMER = setTimeout(onHandleClose, DELAY);
        return () => clearTimeout(TIMER);
    }, [DELAY, useIsVisible]);

    if (!useIsVisible || show === false) return null;

    return (
        <Alert variant={type ?? FALLBACK.type} onClose={onHandleClose} dismissible={dismissible ?? FALLBACK.dismissible}
            className={LS('alert')} >
            {
                (title ?? FALLBACK.title) && (
                    <Alert.Heading className={LS('heading')}>{title ?? FALLBACK.title}</Alert.Heading>
                )
            }
            {children ?? FALLBACK.text}
        </Alert>
    );
};
